import type { RouteLocationNormalized, RouteRecordRaw } from 'vue-router'

export const salesAdminRouter: RouteRecordRaw[] = [
  {
    children: [
      {
        component: async () => import('../views/SalesAdminListView.vue'),
        meta: {
          authZ: ({ user }) => user.hasRole('pb:super'),
          title: 'sales.dashboard',
        },
        name: 'admin.sales',
        path: '',
      },
      {
        // Billing-admin quote-approval inbox. Route-gated to pb:super (staff);
        // the backend SalesAdmin allowlist is authoritative and renders a
        // "not a billing admin" state for non-approvers.
        component: async () =>
          import('../quote-builder/views/QuoteApprovalsInbox.vue'),
        meta: {
          roles: ['pb:super'],
          title: 'sales.approvals',
        },
        name: 'admin.sales.approvals',
        path: 'approvals',
      },
      {
        // Quote approval preview + decision. Linked directly from the Slack
        // approval message ({HERMES_URL}/admin/sales/approvals/:approvalRequestId).
        component: async () =>
          import('../quote-builder/views/QuoteApprovalDetail.vue'),
        meta: {
          roles: ['pb:super'],
          title: 'sales.approvals',
        },
        name: 'admin.sales.approval-detail',
        path: 'approvals/:approvalRequestId',
        props: (route: RouteLocationNormalized) => ({
          approvalRequestId: route.params.approvalRequestId,
        }),
      },
      {
        children: [
          {
            component: async () =>
              import('../components/SalesLocationTable.vue'),
            name: 'admin.sales.brand.locations',
            path: 'locations',
            props: (route: RouteLocationNormalized) => ({
              brandId: route.params.brandId,
            }),
          },
          {
            component: async () => import('../components/SalesTeamSection.vue'),
            name: 'admin.sales.brand.team',
            path: 'team',
            props: (route: RouteLocationNormalized) => ({
              brandId: route.params.brandId,
            }),
          },
          {
            // Keep the pre-rename `quote-builder` path resolving so reps with the
            // old URL bookmarked or open in a tab don't 404 after this ships.
            alias: 'quote-builder',
            component: async () =>
              import('../quote-builder/views/QuoteBuilderTab.vue'),
            name: 'admin.sales.brand.quote-builder',
            // Optional `:quoteId` so the open quote lives in the URL
            // (deep-linkable + shareable, and survives a responsive remount).
            // `quotes/<id>` and `quotes` are the same route record, so opening or
            // closing a quote is a param change, not a remount.
            path: 'quotes/:quoteId?',
            props: (route: RouteLocationNormalized) => ({
              brandId: route.params.brandId,
              quoteId: route.params.quoteId || null,
            }),
          },
        ],
        component: async () => import('../views/SalesAdminBrandView.vue'),
        meta: {
          authZ: ({ user }) => user.hasRole('pb:super'),
          title: 'sales.dashboard',
        },
        name: 'admin.sales.brand',
        path: 'brands/:brandId',
        props: (route: RouteLocationNormalized) => ({
          brandId: route.params.brandId,
        }),
        redirect: { name: 'admin.sales.brand.locations' },
      },
    ],
    component: async () => import('../views/SalesAdminView.vue'),
    meta: {
      authZ: ({ user }) => user.hasRole('pb:super'),
    },
    path: 'admin/sales',
  },
]
